import { Component, OnInit } from '@angular/core';
import { HeadlessView } from '../../../common/shared/components/headless-view';
import { LayoutService } from '../../../common/layout/layout.service';
import { MobileDetectorService } from '../../../common/shared/mobile-detector.service';
import { ActivatedRoute } from '@angular/router';
import { MyDocumentsService } from '../my-documents.service';
import { CreateMessageService } from '../../create-message/create-message.service';

@Component({
    selector: 'ns-my-documents',
    templateUrl: './my-documents.component.html',
    styleUrls: ['./my-documents.component.scss']
})
export class MyDocumentsComponent extends HeadlessView implements OnInit {

    public myDocuments;

    constructor(
        protected layoutService: LayoutService,
        protected mobileDetectorService: MobileDetectorService,
        private activatedRoute: ActivatedRoute,
        private myDocumentsService: MyDocumentsService,
        private createMessageService: CreateMessageService
    ) {
        super(layoutService, mobileDetectorService);

        this.myDocuments = activatedRoute.snapshot.data['myDocuments'];

        this.layoutService.enableFooter();
    }

    ngOnInit(): void {
    }

    public onSaveFile(formData) {
        if (formData) {
            this.myDocumentsService.saveFile(formData).then(() => {
                this.createMessageService.getMyDocumentsListObservable().subscribe(data => {
                    this.myDocuments = data;
                });
            });
        }
    }
}
